/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Vladimir Prudilin
 *
 * Shows an overlay above entire screen or specified element
 *
 * Examples:
 * to cover .item block:
 * var overlay = new ActionInProgressOverlay({el: '.item'});
 *
 * or for fullscreen overlay (covers current viewport):
 * var overlay = new ActionInProgressOverlay();
 *
 * overlay.show();
 */
define(['jquery', 'assets/js/modules/View', 'underscore'], function($, View, _) {
    var overlayTpl = _.template('<div class="<%= className %>"><div class="progress-bar"></div></div>');

    return View.extend({
        overlayHtml: null,
        active: false,
        added: false,
        fullscreen: true,

        initialize: function(options) {
            if (options && options.el) {
                this.fullscreen = false;
            } else {
                this.$el = $('body');
            }

            this.overlayHtml = overlayTpl({
                className: this.getOverlayClass()
            });
        },

        show: function() {
            if (!this.active) {
                this.active = true;
                if (!this.added) {
                    this.added = true;
                    this.$el.prepend(this.overlayHtml);
                    this.$overlay = this.$('.' + this.getOverlayClass());
                }

                this.$overlay.addClass('is-active');
            }
        },

        hide: function() {
            if (this.active) {
                this.active = false;

                this.$overlay.removeClass('is-active');
            }
        },

        getOverlayClass: function() {
            return this.fullscreen ? 'action-in-progress-full-screen-overlay' : 'action-in-progress-overlay';
        }
    });
});
